/**
 * True when Rentalyzer is already running as an installed app
 * (Android/desktop standalone, or iOS "Add to Home Screen").
 */
export function isStandaloneDisplayMode() {
  if (typeof window === 'undefined') return false;

  try {
    if (window.matchMedia('(display-mode: standalone)').matches) return true;
  } catch {
    // matchMedia can throw in non-browser test environments
  }

  // iOS Safari (legacy standalone flag, not exposed via display-mode on older iOS)
  if (window.navigator?.standalone === true) return true;

  return false;
}
